/** Represents groups of widgets. Used to identify widgets */
export var WidgetGroup;
(function (WidgetGroup) {
    /** None widget group. */
    WidgetGroup[WidgetGroup["None"] = 0] = "None";
    /** The group of widgets responsible for the Model. */
    WidgetGroup[WidgetGroup["Model"] = 1] = "Model";
    /** The group of widgets responsible for the Query. */
    WidgetGroup[WidgetGroup["Query"] = 2] = "Query";
    /** The group of widgets responsible for the Result. */
    WidgetGroup[WidgetGroup["Result"] = 4] = "Result";
    /** The group of widgets responsible for the statement. */
    WidgetGroup[WidgetGroup["Statement"] = 8] = "Statement";
    /** The group of widgets responsible for tracking Query status. */
    WidgetGroup[WidgetGroup["QueryStatus"] = 16] = "QueryStatus";
    /** All. */
    WidgetGroup[WidgetGroup["All"] = 65535] = "All";
})(WidgetGroup || (WidgetGroup = {}));
//# sourceMappingURL=widget_group.js.map